<template>
  <div class="password-popup">
    <header>Должен содержать:</header>
    <main>
      <ul>
        <li>
          <component
            :is="
              passwordValidator.$model &&
              passwordValidator.minLength &&
              passwordValidator.$dirty
                ? 'OkRoundIcon'
                : 'ErrorRoundIcon'
            "
          />
          Минимум 8 символов;
        </li>
        <li>
          <component
            :is="
              passwordValidator.$model &&
              passwordValidator.maxLength &&
              passwordValidator.$dirty
                ? 'OkRoundIcon'
                : 'ErrorRoundIcon'
            "
          />
          Максимум 64 символа;
        </li>
        <li>
          <component
            :is="
              passwordValidator.uppercase && passwordValidator.$dirty
                ? 'OkRoundIcon'
                : 'ErrorRoundIcon'
            "
          />
          Заглавные буквы латинского алфавита;
        </li>
        <li>
          <component
            :is="
              passwordValidator.lowercase && passwordValidator.$dirty
                ? 'OkRoundIcon'
                : 'ErrorRoundIcon'
            "
          />
          Строчные буквы латинского алфавита;
        </li>
        <li>
          <component
            :is="
              passwordValidator.numbers && passwordValidator.$dirty
                ? 'OkRoundIcon'
                : 'ErrorRoundIcon'
            "
          />
          Цифры.
        </li>
      </ul>
    </main>
  </div>
</template>

<script>
import OkRoundIcon from '@/components/Icons/OkRoundIcon';
import ErrorRoundIcon from '@/components/Icons/ErrorRoundIcon';

export default {
  name: 'PasswordPopup',
  components: {
    OkRoundIcon,
    ErrorRoundIcon
  },
  props: {
    passwordValidator: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
@import 'src/style/utils';

.password-popup {
  @include uiFont;

  header {
    @extend %text-500-14;
    margin-bottom: 10px;
  }

  main {
    @extend %text-400-14;
    ul {
      li {
        display: flex;
        align-items: center;
        line-height: 1;

        & > svg {
          margin-right: 8px;
        }
      }

      li:not(:last-child) {
        margin-bottom: 8px;
      }
    }
  }
}
</style>
